import { ClipLoader } from "react-spinners";

const FullscreenLoader = () => {

    return (
        <div className="w-100 h-100 d-flex justify-content-center align-items-center">
            <ClipLoader
                color="var(--bs-primary)"
                loading={true}
                size={250}
                aria-label="Loading Spinner"
                data-testid="loader"
            />
        </div>
    )
}

export default FullscreenLoader;